import { renderSearchResultBanners } from '../../components/search-result-banners-render';
import { HorseshoeConfig } from '../../../shared/types/podlet';

export function handleLastMinute(config: HorseshoeConfig, delay?: number) {
    renderSearchResultBanners(
        'lmsResults',
        {
            deviceType: config.deviceType,
            vertical: 'travel',
            subvertical: 'lastminute',
            showBanners: true,
            id: 'temp',
            grid: false,
            type: 'ast',
        },
        delay,
    );
}
